module.exports = __webpack_public_path__ + "img/idigi-bengkelnet.8f9ef236.png";